import React, { Fragment, useState, useEffect } from "react";
import CaptureView from "./capture";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ToastNotification from "../../utils/toast";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function Main() {
  const [violations, setViolations] = useState("");
  const [show, setShow] = useState(false)
  const [testView, setTestView] = useState(false);
  const [count, setCount] = useState(0)
  // const [loading, setLoading] = useState(Number(localStorage.getItem('reloadCount')) || 0);
  const history = useHistory();
  const error = useSelector(state => state.error);


  useEffect(() => {


    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });

    // Prevent Ctrl+S, Ctrl+C & Ctrl+V
    document.onkeydown = function (e) {
      e = e || window.event; //Get event
      if (e.ctrlKey) {
        var c = e.code; //Get key code
        if (["KeyS", "KeyC", "KeyV"].includes(c)) {
          e.preventDefault();
          e.stopPropagation();
          setShow(true);
          setViolations("Ctrl + S, Ctrl+C, Ctrl+V not allowed");
          setCount(count + 1);
        }
      }
      if (e.keyCode === 123) {
        return false;
      }

      // disable I key
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        return false;
      }

      // disable J key
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        return false;
      }

      // disable U key
      if (e.ctrlKey && e.keyCode === 85) {
        return false;
      }
    };

    // detect tab switching
    document.addEventListener("visibilitychange", (event) => {
      if (document.visibilityState !== "visible") {
        setShow(true);
        setViolations("Tab switching not allowed");
        setCount(count + 1);
      }
    });

    // full screen detection - chrome
    document.addEventListener("webkitfullscreenchange", function () {
      // full screen disabled
      if (!document.fullscreenElement) {
        setShow(true)
        setViolations("Exiting Full Screen not allowed");
        setCount(count + 1);
      }
      goFullScreen();
    });

    return (() => {
      document.removeEventListener("visibilitychange", (event) => {
        if (document.visibilityState !== "visible") {
          setShow(true);
          setViolations("Tab switching not allowed");
          setCount(count + 1);
        }
      });
      document.removeEventListener("webkitfullscreenchange", function () {
        // full screen disabled
        if (!document.fullscreenElement) {
          setShow(true)
          setViolations("Exiting Full Screen not allowed");
          setCount(count + 1);
        }
        goFullScreen();
      });
    })
  });





  const goFullScreen = () => {
    const element = document.body;
    if (element.requestFullScreen) {
      element.requestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };

  const setClose = () => {
    setShow(false)
    goFullScreen();
  }
  console.log(history.location.state)
  return (
    <div className="remove-mobile-bg">
      {violations !== '' &&
        <div >
          <ToastNotification
            message={violations !== '' && violations}
            show={show}
            setClose={setClose}
          />
        </div>
      }

      {
        // window.innerWidth > 767 ?
        <div style={{ background: `rgb(${"240,240,250"})`, overflow: 'auto', pointerEvents: show ? 'none' : 'auto' }}>
          <CaptureView
            violations={violations}
            setViolations={setViolations}
            testViewState={setTestView}
            testId={history.location.state.skillId}
            title={history.location.state.name}
            details={history.location.state.details}
            learn={history.location.state.learn}
            unlock={history.location.state.proctored}
            count={count}
          />
        </div>
        // :
        // <div className="mobile-coming">
        //   <div className="mobile-inner-hide">
        //     <img src="/images/mobile-error.svg" alt='' />
        //     <h4>Please visit the website on your Desktop/Laptop</h4>
        //     <p>Mobile view coming soon</p>
        //   </div>

        // </div>
      }
      <Modal
        show={error.successMessage}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={this.handleCloseModal}
        dialogClassName={"confirm-modal"}
      >
        <div className="p-3 text-center">
          <Fragment>
            <h1 style={{ fontSize: 18 }}>Something went wrong! Please reload the test.</h1>
            <div className="save-btn">
              <button onClick={() => {
                window.location.reload(false);
              }}>Reload Now</button>
            </div>
          </Fragment>
        </div>
      </Modal>
    </div >
  );
}
